import { useQuery } from "@tanstack/react-query";

import { contactQuery } from "#modules/contacts/infra/contact.query";

export const useContact = (id: string | undefined) => {
  const { data, ...rest } = useQuery({ ...contactQuery(id) });

  return { contact: data, ...rest };
};
